import styled from 'styled-components'

export const Wrapper = styled.div<{
  isVisible: boolean
}>`
  position: relative;
  z-index: 2;
  min-height: 100dvh;

  > div[id='current-tab'] {
    opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
    transition: opacity 240ms ease-in-out;
  }
`
